export default "__VITE_ASSET__BzVCWOif__"